module.exports = __webpack_public_path__ + "static/media/video2.485a0bab.jpg";